import { FunctionComponent } from "react"
import { Link } from "react-daisyui"
import Modal from "./modal"

type HelpModalProps = {
  isHelpModalOpen: boolean
  setHelpModalOpen: (isOpen: boolean) => void
  modalTitle?: string
}

const HelpModal: FunctionComponent<HelpModalProps> = ({
  isHelpModalOpen,
  setHelpModalOpen,
  modalTitle,
}) => {
  const handleChatClick = () => {
    if (
      "BrevoConversations" in window &&
      typeof window["BrevoConversations"] === "function"
    ) {
      window.BrevoConversations("show")
      window.BrevoConversations("openChat", true)
      window.BrevoConversations("startBotScenario", "xCYnqADFQyvHygy3c")
    }
  }

  const brevoLink = () => {
    if ("BrevoConversations" in window) {
      return (
        <span>
          {" "}
          or using our{" "}
          <Link color="primary" onClick={handleChatClick}>
            live chat
          </Link>
        </span>
      )
    } else {
      return <span />
    }
  }

  return (
    <Modal
      id="helpModal"
      headerIcon="/v3/assets/help-circle.svg"
      title={modalTitle || "Simulation Help"}
      open={isHelpModalOpen}
      okButton={{
        name: "Close",
        onClick: () => setHelpModalOpen(false),
      }}
      onClose={() => setHelpModalOpen(false)}>
      <div>
        If you have questions regarding the interface or are facing any
        technical challenges, please directly contact our support team via{" "}
        <Link href="mailto:support@meseekna.com" color="primary">
          email
        </Link>
        {brevoLink()}.
      </div>
    </Modal>
  )
}

export default HelpModal
